
export class StudioDate extends Date {
  FormatDate(): string {
    if (this) {
      return this.getDate() + "/" + (this.getMonth() + 1) + "/" + this.getFullYear();
    }
    else {
      return "";
    }
  }
}
